export const makeContextOptionsApiRoutes = () => {
  const routes = {
    contextOptions: (userId = ":userId") => `/users/${userId}/context-options`,
  }
  return routes
}
